import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import GateGuard from "@/components/GateGuard";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Borrowers from "@/pages/Borrowers";
import BorrowerDetail from "@/pages/BorrowerDetail";
import GroupObligors from "@/pages/GroupObligors";
import GroupObligorDetail from "@/pages/GroupObligorDetail";
import Facilities from "@/pages/Facilities";
import FacilityDetail from "@/pages/FacilityDetail";
import Exposures from "@/pages/Exposures";
import Collaterals from "@/pages/Collaterals";
import Guarantors from "@/pages/Guarantors";
import Covenants from "@/pages/Covenants";
import Approvals from "@/pages/Approvals";
import GraphView from "@/pages/GraphView";
import ConnectedObligors from "@/pages/ConnectedObligors";
import Alerts from "@/pages/Alerts";
import Reports from "@/pages/Reports";
import ProductGuide from "@/pages/ProductGuide";
import Integrations from "@/pages/Integrations";

function App() {
  return (
    <GateGuard>
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/borrowers" element={<Borrowers />} />
            <Route path="/borrowers/:id" element={<BorrowerDetail />} />
            <Route path="/groups" element={<GroupObligors />} />
            <Route path="/groups/:id" element={<GroupObligorDetail />} />
            <Route path="/facilities" element={<Facilities />} />
            <Route path="/facilities/:id" element={<FacilityDetail />} />
            <Route path="/exposures" element={<Exposures />} />
            <Route path="/collaterals" element={<Collaterals />} />
            <Route path="/guarantors" element={<Guarantors />} />
            <Route path="/covenants" element={<Covenants />} />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/graph" element={<GraphView />} />
            <Route path="/connected-obligors" element={<ConnectedObligors />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/product-guide" element={<ProductGuide />} />
            <Route path="/integrations" element={<ProtectedRoute roles={["admin"]}><Integrations /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </GateGuard>
  );
}

export default App;
